import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { H3, H5, NamedLink, PrimaryButton } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';
import Placeholder from './NoSearchResultPlaceholder';
import InquiryModal from '../../LandingPage/InquiryModal/InquiryModal';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  const [isQueryOpend, setIsQueryOpend] = useState(true);
  useEffect(() => {});
  const [isOpen, setIsOpen] = useState(false);

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <InquiryModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        onCloseInquirySend={() => {}}
      />
      <div className={css.noResults}>
        <FormattedMessage id="SearchPage.noResults" />
        <H5 as="h2">
          <FormattedMessage id="SearchPage.noResultsMessage" />
        </H5>

        {hasSearchParams ? (
          <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
            <FormattedMessage id={'SearchPage.resetAllFilters'} />
          </button>
        ) : null}
        <br />
        <Placeholder />
      </div>
      <div className={css.container_button}>
        <PrimaryButton
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <FormattedMessage id="SearchPage.tellUsWhatYouNeed" />
        </PrimaryButton>
      </div>
      {/* <p>
        <NamedLink className={css.createListingLink} name="NewListingPage">
          <FormattedMessage id="SearchPage.createListing" />
        </NamedLink>
      </p> */}
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
